module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list px-2 py-2"
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.sex_code.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][3]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.sex_code),
      expression: "input.sex_code"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "sex_code",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.sex_code, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.sex_code.$touch()
      },
      "__c": function($event) {
        _vm.input.sex_code = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][4]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.sex_code),
      expression: "input.sex_code"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "sex_code",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.sex_code, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.sex_code.$touch()
      },
      "__c": function($event) {
        _vm.input.sex_code = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][5]"
    }
  })], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.sex_code,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][1]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.generation_code.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][6]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.generation_code),
      expression: "input.generation_code"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.generation_code = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.generation_code.$touch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][7]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][8]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][9]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][10]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][11]"
    }
  })], 1)])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.generation_code,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][2]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q1_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q1.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][12]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q1_answer),
      expression: "input.q1_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q1",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q1_answer, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q1_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q1_answer = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][13]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q1_answer),
      expression: "input.q1_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q1",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q1_answer, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q1_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q1_answer = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][14]"
    }
  })], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q1_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][3]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q2_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q2.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][15]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q2_answer),
      expression: "input.q2_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q2",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q2_answer, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q2_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q2_answer = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][16]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q2_answer),
      expression: "input.q2_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q2",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q2_answer, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q2_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q2_answer = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][17]"
    }
  })], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q2_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][4]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q3_answer_group.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q3.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][18]"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q3_answer),
      expression: "input.q3_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q3",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q3_answer, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q3_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q3_answer = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][19]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q3_answer),
      expression: "input.q3_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q3",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q3_answer, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q3_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q3_answer = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][20]"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q3_answer),
      expression: "input.q3_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q3",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q3_answer, "3")
    },
    on: {
      "__c": function($event) {
        _vm.input.q3_answer = "3"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][21]"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q3_answer_free_text),
      expression: "input.q3_answer_free_text"
    }],
    staticClass: "form-control ml-2 mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input.q3_answer_free_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.q3_answer_free_text = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q3_answer_group,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][5]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q4_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q4.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][22]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q4_answer),
      expression: "input.q4_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q4",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q4_answer, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q4_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q4_answer = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][23]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q4_answer),
      expression: "input.q4_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q4",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q4_answer, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q4_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q4_answer = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][24]"
    }
  })], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q4_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][6]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q5_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q5.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][25]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q5_answer),
      expression: "input.q5_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q5",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q5_answer, "1")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q5_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q5_answer = "1"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][26]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q5_answer),
      expression: "input.q5_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q5",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q5_answer, "2")
    },
    on: {
      "change": function($event) {
        _vm.$v.input.q5_answer.$touch()
      },
      "__c": function($event) {
        _vm.input.q5_answer = "2"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][27]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q5_answer),
      expression: "input.q5_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "q5",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.input.q5_answer, "3")
    },
    on: {
      "__c": function($event) {
        _vm.input.q5_answer = "3"
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][28]"
    }
  })], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q5_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][7]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q6_answer_group.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q6.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][29]"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q6_answer),
      expression: "input.q6_answer"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.q6_answer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.q6_answer.$touch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][30]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][31]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][32]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][33]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][34]"
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][35]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q6_answer_free_text),
      expression: "input.q6_answer_free_text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input.q6_answer_free_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.q6_answer_free_text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q6_answer_group,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][8]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q7.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][36]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q7_answer),
      expression: "input.q7_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q7_answer) ? _vm._i(_vm.input.q7_answer, "1") > -1 : (_vm.input.q7_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q7_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q7_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q7_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q7_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][37]"
    }
  })], 1)]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q7_answer),
      expression: "input.q7_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q7_answer) ? _vm._i(_vm.input.q7_answer, "2") > -1 : (_vm.input.q7_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q7_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q7_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q7_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q7_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][38]"
    }
  })], 1)]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q7_answer),
      expression: "input.q7_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q7_answer) ? _vm._i(_vm.input.q7_answer, "3") > -1 : (_vm.input.q7_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q7_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q7_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q7_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q7_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][39]"
    }
  })], 1)]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q8_answer_group.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q8.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][40]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "1") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][41]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "2") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][42]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "3") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][43]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "4") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][44]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "5") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][45]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "6") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][46]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "7") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][47]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer),
      expression: "input.q8_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q8_answer) ? _vm._i(_vm.input.q8_answer, "8") > -1 : (_vm.input.q8_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q8_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q8_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q8_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q8_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][48]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q8_answer_free_text),
      expression: "input.q8_answer_free_text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input.q8_answer_free_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.q8_answer_free_text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q8_answer_group,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][10]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q9_answer_group.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q9.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][49]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "1") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][50]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "2") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][51]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "3") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][52]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "4") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][53]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "5") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][54]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer),
      expression: "input.q9_answer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.input.q9_answer) ? _vm._i(_vm.input.q9_answer, "6") > -1 : (_vm.input.q9_answer)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.input.q9_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.input.q9_answer = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.input.q9_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.input.q9_answer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][55]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q9_answer_free_text),
      expression: "input.q9_answer_free_text"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.input.q9_answer_free_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.q9_answer_free_text = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q9_answer_group,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][11]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q10_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q10.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][56]"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q10_answer),
      expression: "input.q10_answer"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.q10_answer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.q10_answer.$touch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][57]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][58]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][59]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][60]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][61]"
    }
  })], 1)])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q10_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][12]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q11_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q11.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][62]"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q11_answer),
      expression: "input.q11_answer"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.q11_answer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.q11_answer.$touch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][63]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][64]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][65]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][66]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][67]"
    }
  })], 1)])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q11_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][13]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.q12_answer.$error
    }
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q12.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][68]"
    }
  })], 1), _vm._v(" "), _c('form', {
    staticClass: "form-inline"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q12_answer),
      expression: "input.q12_answer"
    }],
    staticClass: "custom-select mb-2",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.input.q12_answer = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.$v.input.q12_answer.$touch()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][69]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][70]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][71]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][72]"
    }
  })], 1), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][73]"
    }
  })], 1)])])]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.q12_answer,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['10_1'][14]"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(16)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-2 col-form-label"
  }, [_vm._v("Q13.")]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][74]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q13_answer),
      expression: "input.q13_answer"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.input.q13_answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.q13_answer = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[94][75]",
      "adjustLangFontSizes": {}
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-50"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/demo_anc_q7_1.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-50"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/demo_anc_q7_2.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-50"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/demo_anc_q7_3.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5853fc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Order/DemoQuestionnaire/PageForm.vue
// module id = 738
// module chunks = 0